module.exports = __webpack_public_path__ + "static/media/mousecaster.a0dbffda.md";